var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.recaptchaLoaded)?_c('vue-recaptcha',{ref:"recaptcha",staticClass:"g-recaptcha",attrs:{"sitekey":_vm.publicKey,"size":_vm.size},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.onCaptchaExpired}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }